export const siteModule = 'yoda-site-components';
export const siteCommonSuffix = 'site_common';
